/**
 * Centralized Route Paths
 * Update paths here if you need to change them in the future.
 */

// Authentication Routes
export const AUTH_PATHS = {
  LOGIN: "/login",
  REGISTER: "/register",
  FORGOT_PASSWORD: "/forgot-password",
  LOGOUT: "/logout",
  LICENSE_EXPIRED: "/license-expired",
  RESET_PASSWORD: "/reset-password",
  CREATE_PASSWORD: "/auth/createpassword",
  RESET_FORGOT_PASSWORD: "/auth/resetforgotpassword",
  SECURITY_ALERT: "/securityalert",
  MULTITAB_RESTRICT: "/multitabrestrict",
  UNAUTHORIZED: "/unauthorized",
};

// Common Utilities
export const COMMON_PATHS = {
  PDF_VIEWER: "/pdf-viewer",
};

// User Routes
export const VOLUNTEER_PATHS = {
  USER_MANAGEMENT: "/user",
  ROLE: "/list",
  LIST: "/volunteer",
  DETAILS: "/volunteer/details"
};

//Block Volunteer 
export const BLOCK_VOLUNTEER_PATHS = {
  ADD: "/block-volunteer/add",
  EDIT: "/block-volunteer/edit/:id",
  VIEW: "/block-volunteer/view/:id",
  LIST: "/block-volunteer/list",
};

//Pre-Block Volunteer
export const PRE_BLOCK_VOLUNTEER_PATHS = {
  ADD: "/pre-block-volunteer/add",
  EDIT: "/pre-block-volunteer/edit/:id",
};

//Dropout Volunteer
export const DROPOUT_VOLUNTEER_PATHS = {
  ADD: "/dropout-volunteer/add",
  EDIT: "/dropout-volunteer/edit/:id",
  VIEW: "/dropout-volunteer/view/:id",
  LIST: "/dropout-volunteer/list",
};

//Transfer Volunteer
export const TRANSFER_VOLUNTEER_PATHS = {
  ADD: "/transfer-volunteer/add",
  EDIT: "/transfer-volunteer/edit/:id",
  VIEW: "/transfer-volunteer/view/:id",
  LIST: "/transfer-volunteer/list",
};


export const STUDY_VOLUNTEER_PATHS = {
  DETAILS: "/study-volunteer/details"
}

// Dashboard Routes (if you add later)
export const DASHBOARD_PATHS = {
  HOME: "/dashboard",
  DEFAULT: "/dashboard",
  SETTINGS: "/settings",
  FEATURE_ACTIVATION: "/feature-activation",
  ANALYTICS: "/dashboard/analytics",
  ACTIVITY: "/dashboard/activities"
};

export const STUDY_PATHS = {
  LIST: "/study/list",
  DETAILS: "/study/detail/*",
  SCREENING: "/study/screening/*",
  VISIT_DETAILS: "study/detail/visit",
  SCREENING_LIST: "/study/screeninglist",
  DASHBOARD: "/study/dashboard",
  SINGLE_DASHBOARD: "/study/single-dashboard/:id",
  SINGLE_DASHBOARD_DEFAULT: "/study/single-dashboard",
  CHECKLIST_MANAGE : "/study/checklist-manage"
}



export const MASTER_STUDY_PATHS = {
  LIST: "/master/study",
  DETAILS: "/master/study/details/*",
  HISTORY_DETAILS: "/master/study/history-details/:id/*",
  ROLE: "/role",
  TEAMS: "/team",
  ADD: "/study/add",
  ATTACHMENTS: "/attachments",
}

export const STUDY_LITE_PATHS = {
  LIST: "/master/study-lite",
  ADD: "/master/study-lite/add",
  EDIT: "/master/study-lite/edit/:id",
  VIEW: "/master/study-lite/view/:id",
}


export const MASTER_AE_PATHS = {
  DASHBOARD: "/adverse-event",
  LIST: "/adverse-event/list",
  ADD: "/adverse-event/add",
  EDIT: "/adverse-event/edit/:id",
  VIEW: "/adverse-event/view/:id",
}

export const MASTER_TG_PATHS = {
  LIST: "/training-group/list",
  ADD: "/master/training-group/add",
  EDIT: "/master/training-group/edit/:id",
  VIEW: "/master/training-group/view/:id",
  ASSIGN_TRAINING: "/master/training-group/assign/:id",
}

export const IP_PATHS = {
  ADD: "/investigational-product/add",
  EDIT: "/investigational-product/edit/:id",
  LIST: "/investigational-product/list",
  VIEW: "/investigational-product/view/:id",
};

export const DISPENSING_LOG_PATHS = {
  ADD: "/dispensing-log/add",
  LIST: "/dispensing-log/list",
  EDIT: "/dispensing-log/edit/:id",
  VIEW: "/dispensing-log/view/:id",
}

export const LINE_CLEARANCE_PATHS = {
  ADD: "/line-clearance/add",
  EDIT: "/line-clearance/edit/:id",
  VIEW: "/line-clearance/view/:id",
  LIST: "/line-clearance/list",
}

export const RETURNS_LOG_PATHS = {
  ADD: "/returns-log/add",
  LIST: "/returns-log/list",
  EDIT: "/returns-log/edit/:id",
  VIEW: "/returns-log/view/:id"
}

export const ALIQOUT_PATHS = {
  LIST: "/aliquot/list"
}

export const SPONSOR_PATHS = {
  LIST: "/sponsor/list"
}
export const MASTER_PERIOD_PATHS = {
  LIST: "/period/list",
}

export const SUBJECT_CHECKIN_PATHS = {
  LIST: "/study/subject-checkin",
  VIEW: "/study/subject-checkin/view/:id",
};

export const SUBJECT_CHECKOUT_PATHS = {
  LIST: "/study/subject-checkout",
  VIEW: "/study/subject-checkout/view/:id",
};

export const SUBJECT_ADMISSION_PATHS = {
  LIST: "/study/subject-admissions",
  EDIT: "/study/subject-admissions/edit/:id",
  VIEW: "/study/subject-admissions/view/:id",
};



export const LIBRARY_PATHS = {
  CODE_LIST: "/codelist/list",
  CRF_LIST: "/crf/list",
  CRF_PREVIEW: "/crf/view/:id",
  CRF_ADD: "/crf/add",
  CRF_EDIT: "/crf/edit/:id",
  CHECKLIST_LIST: "/checklist/list",
  CHECKLIST_DETAIL: "/checklist/list/:type?",
  DESIGN_LIST: "/design/list",
  WORKFLOW_LIST: "/workflow/list",
  WORKFLOW_ADD: "/workflow/add",
  WORKFLOW_VIEW: "/workflow/view/:id",
  WORKFLOW_EDIT: "/workflow/edit/:id",
  ROLE_LIST: "/role/list",
  USER_LIST: "/user/list",
  TEMPLATE_LIST: "/template/list",
  TEMPLATE_ADD: "/template/add",
  TEMPLATE_EDIT: "/template/edit/:id",
  TEMPLATE_VIEW: "/template/view/:id",
  ASSIGN_RIGHTS: "/assign-rights/:id",
}

export const AMBULATORY_VISIT_PATHS = {
  VIEW: "/ambulatory-visit/view/:id",
  LIST: "/ambulatory",
  DETAIL: "/ambulatory-visit/detail/:visitId",
  SUBJECT_DETAIL: "/ambulatory-visit/detail/:visitId/subject/:subjectId",
  SUBJECT_VIEW: "/ambulatory-visit/detail/:visitId/subject/:subjectId/view"
}


export const VISIT_PATHS = {
  DETAILS: "/visit/detail",
  CRF_EDITOR: "/visit/crf-editor"
}

export const SUBJECT_PATHS = {
  DETAILS: "/subject/detail",
  VIEW: "/subject/view",
  INFO: "/study/detail/subject/subjectinfo",
  INFO_PERIODS: "/study/detail/subject/subjectinfo/periods",
  INFO_ADVERSE_EVENTS: "/study/detail/subject/subjectinfo/adverse-events",
  INFO_SUGGESTIONS: "/study/detail/subject/subjectinfo/suggestions",
  INFO_SUBJECT_ACTION: "/study/detail/subject/subjectinfo/subject-actions",
}

export const SITE_PATHS = {
  SITE_LIST: "/site/list"
}

export const DISPATCH_PATHS = {
  LIST: "/study/detail/dispatch",
  DETAIL: "/study/detail/dispatch/:boxId",
  VIEW: "/study/detail/dispatch/view/:boxId",
};

export const STOCK_RECONCILIATION_PATHS = {
  LIST: "/stock-reconciliation/list",

  // ADD: "/stock-reconciliation/add",
  // EDIT: "/stock-reconciliation/edit/:id",
};

export const PRINT_LABEL_PATHS = {
  TABS: "/print-labels",
};

export const PRINT_HISTORY_PATHS = {
  LIST: "/print-labels-history/list",
};

export const ACCESSIONING_PATHS = {
  LIST: "/accessioning/list",
  LOGS: "/accessioning/logs/:id",
  SESSION: "/accessioning/session/:id",
  DASHBOARD: "/accessioning/dashboard",
  MANUAL_ENTRY: "/accessioning/manual-entry",
};

export const VERIFICATION_PATHS = {
  SAMPLE_COLLECTION: "/verification/sample-collection/:periodid",
};

export const RETENTION_PATHS = {
  ADD: '/drug-retention/add',
  EDIT: '/drug-retention/edit/:id',
  LIST: '/drug-retention/list',
  VIEW: '/drug-retention/view/:id'
};

export const DISPOSAL_PATHS = {
  ADD: '/drug-disposal/add',
  EDIT: '/drug-disposal/edit/:id',
  LIST: '/drug-disposal/list',
  VIEW: '/drug-disposal/view/:id'
};

export const TRANSFER_PATHS = {
  ADD: '/drug-transfer/add',
  EDIT: '/drug-transfer/edit/:id',
  LIST: '/drug-transfer/list',
  VIEW: '/drug-transfer/view/:id'
};

export const STUDY_DESIGN_PATHS = {
  TABS: "/study-design/tabs",
};

export const AUDIT_PATHS = {
  LOGS: "/audit/logs",
  USER_ACTIVITY: "/audit/user-activity",
};

export const SCANNING_PATHS = {
  VIEW: "/scanning",
  SESSION: "/scanning/session/:id",
  LOGS: "/scanning/logs/:id",
};
export const REPORTS_PATHS = {
  SUMMARY: "/summary-reports",
  STOCK_SUMMARY: "/summary-reports/stock-summary",
  EXPIRING_SOON: "/summary-reports/expiring-soon",
  SUBJECT_WISE: "/summary-reports/subject-wise",
  STOCK_LEDGER: "/summary-reports/stock-ledger",
};
